import { track } from '@leagueplatform/analytics';
import {
  Box,
  css,
  genesisStyled,
  QuietButton,
  VisuallyHidden,
} from '@leagueplatform/genesis-commons';
import { useIntl } from '@leagueplatform/locales';
import { Icon, ICONS, Modal } from '@leagueplatform/ui-kit';

import * as React from 'react';

type HealthLiteracyModalProps = {
  ariaLabelledBy: string;
  onClose: () => void;
  children: JSX.Element | JSX.Element[];
  metric?: string;
};
const StyledModalContainer = genesisStyled(Modal.Container)(
  css({
    position: 'relative',
    maxWidth: 620,
    borderRadius: 'medium',
    overflow: 'auto',
  }),
);

const StyledModalBody = genesisStyled(Modal.Body)(
  css({
    padding: 'oneAndHalf',
    paddingTop: 'half',
  }),
);

export const HealthLiteracyModal = ({
  ariaLabelledBy,
  onClose,
  children,
  metric,
}: HealthLiteracyModalProps) => {
  const { formatMessage } = useIntl();
  React.useEffect(() => {
    if (metric) {
      track('dashboard.screen_loaded.metric_info', {
        metric_id: '',
        metric_type: metric,
        metric_status: '',
      });
    }
  }, [metric]);

  return (
    <Modal.Wrapper onClose={onClose}>
      <StyledModalContainer aria-labelledby={ariaLabelledBy}>
        <Box position="absolute" insetInlineEnd="5px" top="5px">
          <QuietButton onClick={onClose}>
            <VisuallyHidden>{formatMessage({ id: 'CLOSE' })}</VisuallyHidden>
            <Icon icon={ICONS.CLOSE} size={16} aria-hidden="true" />
          </QuietButton>
        </Box>
        <StyledModalBody>{children}</StyledModalBody>
      </StyledModalContainer>
    </Modal.Wrapper>
  );
};
